// Single place to render times in 24h (no am/pm). es-AR defaults to 12h in browsers,
// so hourCycle is forced instead of relying on the locale.
const LOCALE = 'es-AR';

const toDate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

// '15:05' or '15:05:09' (seconds: true)
export const formatTime24 = (value, { timeZone, seconds = false, fallback = '' } = {}) => {
  const d = toDate(value);
  if (!d) return fallback;
  return d.toLocaleTimeString(LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    ...(seconds && { second: '2-digit' }),
    hourCycle: 'h23',
    timeZone,
  });
};

// '26/10/2026 15:05'. dateOptions replaces the default date part (e.g. { weekday: 'short', day: 'numeric', month: 'short' }).
export const formatDateTime24 = (
  value,
  { timeZone, seconds = false, fallback = '', dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' } } = {},
) => {
  const d = toDate(value);
  if (!d) return fallback;
  return d.toLocaleString(LOCALE, {
    ...dateOptions,
    hour: '2-digit',
    minute: '2-digit',
    ...(seconds && { second: '2-digit' }),
    hourCycle: 'h23',
    timeZone,
  });
};
